import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    const forms = document.querySelectorAll('.needs-validation');

    forms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        this.clearErrors(form); // Clear previous errors

        // Handle case where claimed profile phone does not match phone in form
        if (this.hasClaimedProfilePhoneMismatch(form)) {
          return true;
        }

        // Run custom validations
        this.runCustomValidations(form);

        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          this.showErrors(form); // Show error messages
        }
        form.classList.add('was-validated');
      }, false);

      // Add blur event listener to all input fields for immediate validation feedback
      const inputs = form.querySelectorAll('input, textarea, select');
      inputs.forEach((input) => {
        input.addEventListener('blur', () => {
          if (input.classList.contains('active')) {
            this.clearError(input); // Clear previous errors for this input
            this.runCustomValidation(input); // Run custom validation for this input
            this.showError(input); // Show error message for this input if invalid
          }
        });

        // Add input event listener to each field to remove validation error when it becomes valid
        input.addEventListener('input', () => {
          this.clearError(input); // Clear previous errors for this input
          this.runCustomValidation(input); // Run custom validation for this input
          if (input.checkValidity()) { // Remove error if input becomes valid
            this.clearError(input);
          }
        });
      });
    });
  }

  clearErrors(form) {
    const inputs = form.querySelectorAll('input, textarea, select');
    inputs.forEach((input) => {
      this.clearError(input);
    });
  }

  clearError(input) {
    input.setCustomValidity(''); // Clear any existing custom error message
    const errorElement = this.findOrCreateErrorElement(input);
    errorElement.textContent = ''; // Clear any existing error message
    input.classList.remove('is-invalid');
  }

  runCustomValidations(form) {
    const inputs = form.querySelectorAll('input, textarea, select');
    inputs.forEach((input) => {
      this.runCustomValidation(input);
    });
  }

  hasClaimedProfilePhoneMismatch(form) {
    const hashedProfilePhoneEl = form.querySelector('input[name="hashed_profile_phone"]');
    if (!hashedProfilePhoneEl) return false;

    const hashedProfilePhone = hashedProfilePhoneEl.value
    const inputPhoneEl = form.querySelector('input[name="contact[phone1]"]');
    if (!inputPhoneEl) return false;

    const inputPhone = inputPhoneEl.value.replace(/\D/g, '');
    const hashedPhone = CryptoJS.MD5(inputPhone).toString();

    if (hashedPhone != hashedProfilePhone) {
      form.querySelector('input[name="validation_type"]').value = 'none';
      const phoneEl = form.querySelector('input[name="contact[phone1]"]');
      phoneEl.name = 'unused_phone';
      form.querySelector('input[name="_certificationText"]').value = '';
      form.querySelector('input[name="_certificationUri"]').value = '';
      window.recordEvent('dynamic_tcpa_sms_phone', 'action', 'skipping-claimed-non-matching-phone__sms');
      return true;
    }
    return false;
  }

  runCustomValidation(input) {
    if (input.type === 'email') {
      if (!this.isValidEmail(input.value)) {
        input.setCustomValidity('Please enter a valid email address.');
      } else {
        input.setCustomValidity(''); // Clear error if valid
      }
    } else if (input.type === 'tel') {
      if ((input.name === 'contact[zipcode]' || input.classList.contains('zipcodeUS') || input.classList.contains('zipcode')) && !this.isValidZipCode(input.value)) {
        input.setCustomValidity('Please enter a valid zip code.');
      } else if (!this.isValidPhone(input.value)) {
        input.setCustomValidity('Please enter a valid phone number.');
      } else {
        input.setCustomValidity(''); // Clear error if valid
      }
    }
  }

  showErrors(form) {
    const inputs = form.querySelectorAll('input, textarea, select');
    inputs.forEach((input) => {
      this.showError(input);
    });
  }

  showError(input) {
    if (!input.validity.valid) {
      const errorElement = this.findOrCreateErrorElement(input);
      if (input.validationMessage) {
        errorElement.textContent = input.validationMessage;
      } else {
        errorElement.textContent = 'Please provide a valid value.';
      }
      input.classList.add('is-invalid');
    }
  }

  isValidZipCode(zip) {
    const ZIP_REGEX = /^\d{5}(-\d{4})?$/; // US zip code
    return ZIP_REGEX.test(zip);
  }

  isValidEmail(email) {
    // Using same regex as Odin gem for email validation
    const EMAIL_REGEX = /^([a-zA-Z0-9_\.-])+(\+)?([a-zA-Z0-9_\.\-])*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9]{2,4})+?$/;
    return EMAIL_REGEX.test(email);
  }

  isValidPhone(phone) {
    const PHONE_REGEX = /^\s*\(?([2-9]\d{2})\)?\s*[\.-]?\s*([2-9]\d{2})\s*[\.-]?\s*(\d{4})\s*$/; // US phone number
    return PHONE_REGEX.test(phone);
  }

  findOrCreateErrorElement(input) {
    const errorId = `${input.id}-error`;
    let errorElement = document.getElementById(errorId);
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.id = errorId;
      errorElement.classList.add('invalid-feedback');
      input.parentNode.insertAdjacentElement('afterend', errorElement);
    }
    return errorElement;
  }
}
